import { render, staticRenderFns } from "./Smoking.vue?vue&type=template&id=29ed5b2e&scoped=true"
import script from "./Smoking.vue?vue&type=script&lang=js"
export * from "./Smoking.vue?vue&type=script&lang=js"
import style0 from "./Smoking.vue?vue&type=style&index=0&id=29ed5b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ed5b2e",
  null
  
)

export default component.exports